import UserAvatar from "../../components/global/avtar/UserAvatar";
import { formatDate } from "../../utils/utils";

const columns = [
    {
        title: "User",
        dataIndex: "user",
        render: (_, record) => (
            <UserAvatar
                data={{
                    name: record?.name,
                    email: record?.email,
                    profile_image: record?.profilePic,
                }}
            />
        ),
    },
    {
        title: "Request Date",
        dataIndex: "createdDate",
        render: (value) => formatDate(value),
    },
]

export default columns;